import React from 'react';
import { Trans, withTranslation } from 'react-i18next';

class LegalText extends React.Component {

    render() {
        const content =
            this.props.text
                ?
                this.props.text
                :
                <div>
                    <Trans i18nKey="Premium_Functionality_Text" values={{ featureName: this.props.featureName }}>
                        {{featureName: this.props.featureName}} is a premium functionality. You can create a configuration file using this feature but when programming the drivers, a fee per device will incur.
                    </Trans>
                    <br />
                    <Trans i18nKey="Contact_Sales_Representative" />
                </div>

        return (
            <div className="legal-text">
                {content}
            </div>
        );
    }
}

export default withTranslation()(LegalText);
